import { SearchInput } from "@dust-tt/sparkle";
import { useEffect, useRef, useState } from "react";

interface SidebarSearchProps {
  titleFilter: string;
  onTitleFilterChange: (value: string) => void;
}

export function SidebarSearch({
  titleFilter,
  onTitleFilterChange,
}: SidebarSearchProps) {
  const searchInputRef = useRef<HTMLInputElement>(null);
  const [isOpen, setIsOpen] = useState(() => titleFilter.trim().length > 0);

  useEffect(() => {
    const openSearch = () => {
      setIsOpen(true);
      requestAnimationFrame(() => {
        searchInputRef.current?.focus();
      });
    };
    window.addEventListener("memoair-sidebar-search", openSearch);
    return () => {
      window.removeEventListener("memoair-sidebar-search", openSearch);
    };
  }, []);

  useEffect(() => {
    if (titleFilter.trim().length > 0) {
      setIsOpen(true);
    }
  }, [titleFilter]);

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (
        e.key === "Escape" &&
        document.activeElement === searchInputRef.current
      ) {
        e.preventDefault();
        onTitleFilterChange("");
        setIsOpen(false);
        searchInputRef.current?.blur();
      }
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [onTitleFilterChange]);

  if (!isOpen) {
    return null;
  }

  return (
    <SearchInput
      ref={searchInputRef}
      name="search"
      placeholder="Search"
      value={titleFilter}
      onChange={onTitleFilterChange}
      onBlur={() => {
        if (titleFilter.trim().length === 0) {
          setIsOpen(false);
        }
      }}
    />
  );
}
